module.exports = __webpack_public_path__ + "img/medicine.f88686ca.png";